import PropTypes from 'prop-types';

export const filterOptionPropTypes = {
    option: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        checked: PropTypes.bool,
        count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        type: PropTypes.string
    }).isRequired,
    onOptionChange: PropTypes.func.isRequired
};

export const filterSectionPropTypes = {
    section: PropTypes.shape({
        title: PropTypes.string.isRequired,
        options: PropTypes.array.isRequired
    }).isRequired,
    onFilterChange: PropTypes.func.isRequired
};
